/* eslint-disable */


import { Loader } from '@googlemaps/js-api-loader'
import { useToast } from 'vue-toastification'
const toast = useToast()

export const preventError = (e) => {
  const result = e?.networkError?.result
  const code = result?.error || 'UNKNOWN_ERROR'
  if (code !== 'TRIAL_EXPIRED') {
    toast.error(code)
  }
}

export const createDateTime = (date, format = 'dateTime') => {
  if (!date) return null;
  const newDate = new Date(date).toISOString()
  if (format === 'dateTime') {
    return newDate
  } else if (format === 'date') {
    return newDate.split('T')[0]
  } else if (format === 'time') {
    return newDate.split('T')[1]
  }
}

export const exportNurseLocationHistory = async (url, fileName, institutionId) => {
fetch(url, {
  method: "GET",
  headers: {
    institutionUuid: institutionId
  }
})
  .then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.blob();
  })
  .then((blob) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  })
  .catch((error) => {
    console.error("Error:", error.message);
  });
}

export const initMap = async () => {
  const loader = new Loader({
    apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    version: 'weekly',
    libraries: ['maps', 'marker']
  })
  loader.load().then(async () => {
    const { Map } = await google.maps.importLibrary('maps')

    return new Map(document.getElementById('map'), {
      center: { lat: 59.436962, lng: 24.753574 },
      zoom: 12,
      mapId: 'TEST_MAP_ID',
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      disableDefaultUI: true
    })
  })
}
